import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import DoNotDisturbIcon from '@mui/icons-material/DoNotDisturb';
import { trackEventMatomo } from '../../helpers/matomo';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Stack, TextField } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

export default function ModalDeny({
  mutate,
  status,
  openRefuse,
  setOpenRefuse,
  disabled = false,
}: {
  mutate: (motivo?: string) => void,
  status: string,
  openRefuse: boolean,
  setOpenRefuse: Function,
  disabled?: boolean,
}) {
  const { t } = useTranslation('translation');
  const [motivo, setMotivo] = useState('');

  const close = () => {
    trackEventMatomo('modal recusa chamado', 'click', 'div', 'fecha modal');
    setOpenRefuse(false);
  };

  return (
    <Dialog
      fullWidth
      maxWidth="sm"
      open={openRefuse}
      onClose={() => {
        if (!disabled) close();
      }}
      scroll="paper"
    >
      <DialogTitle>
        {t('notifications.ticket.doYouWant')} {status === 'recusado'
          ? t('notifications.ticket.reject')
          : t('notifications.ticket.cancel')} {t('notifications.ticket.executionOfThisTicket')}
      </DialogTitle>
      <IconButton
        aria-label="fechar"
        onClick={close}
        sx={(theme) => ({
          position: 'absolute',
          right: 8,
          top: 8,
          color: theme.palette.grey[500],
        })}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent dividers>
        <Stack spacing={2}>
          <TextField
            fullWidth
            multiline
            minRows={3}
            label={t("notifications.ticket.optionalReason")}
            value={motivo}
            disabled={disabled}
            onChange={(event) => setMotivo(event.target.value)}
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button
          color="error"
          variant="contained"
          endIcon={<DoNotDisturbIcon />}
          disabled={disabled}
          onClick={() => {
            trackEventMatomo('modal recusa chamado', 'click', 'button', 'salva');
            mutate(motivo.trim() || undefined);
          }}
        >
          {status === 'recusado' ? 'recusar' : 'cancelar'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
